import { AceRecord } from "@cs124/monace";
import { Array, Boolean, Literal, Number, Partial, Record, String, Union } from "runtypes";
export const Versions = Record({
  commit: Record({
    client: String,
    server: String
  }),
  version: Record({
    client: String,
    server: String
  })
});
export const UpdateMessage = Record({
  type: Literal("update"),
  id: String,
  view: String,
  save: String,
  local: Boolean,
  streaming: Boolean,
  unixtime: Number,
  records: Array(AceRecord)
});
export const GetMessage = Record({
  type: Literal("get"),
  id: String,
  local: Boolean
});
export const ClientMessages = Union(UpdateMessage, GetMessage);
export const ServerMessages = Union(UpdateMessage, GetMessage);
export const ConnectionQuery = Record({
  client: String
}).And(
  Partial({
    version: String,
    commit: String
  })
);
export const ServerStatus = Record({
  what: Literal("mace"),
  counts: Record({
    client: Number,
    update: Number,
    get: Number
  }),
  cache: Record({
    hits: Number,
    misses: Number
  })
}).And(
  Partial({
    started: String.withConstraint((s) => !isNaN(Date.parse(s))),
    heartbeat: String.withConstraint((s) => !isNaN(Date.parse(s))),
    version: String,
    commit: String,
    built: String
  })
);
//# sourceMappingURL=types.js.map
